import { useTranslation } from "react-i18next";
import ChemicalSelectionFields from "../ChemicalSelectionFields";

import "./index.scss";

const ChemicalsUsedForCleaning = ({
  chemicalsUsed,
  onChemicalsChange,
  setMandatoryComponentsStatus,
}) => {
  const { t } = useTranslation();

  const handleChemicalChange = (key, option) => {
    onChemicalsChange((prev) => ({
      ...prev,
      [key]: {
        chem_id: option.value,
        chemical_name: option.label,
        price: option.price,
      },
    }));

    if (setMandatoryComponentsStatus) {
      setMandatoryComponentsStatus((prev) => ({
        ...prev,
        chemicalsUsedForCleaning: {
          ...prev.chemicalsUsedForCleaning,
          changed: true,
          fulfilled: true,
          error: false,
        },
      }));
    }
  };

  return (
    <div className="ro-card-wrapper position-relative">
      <div className="ro-card-header">
        <div className="teal-heading">
          {t("chemicalsUsedForCleaning.title")}
        </div>
      </div>

      <ChemicalSelectionFields
        selectedChemicals={chemicalsUsed}
        onChemicalChange={handleChemicalChange}
        containerClassName="chemicals-used-cleaning-grid"
        showPriceField={false}
      />
    </div>
  );
};

export default ChemicalsUsedForCleaning;
